import React, { useRef } from "react";
import emailjs from "@emailjs/browser";

const ContactSection = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_q1j0bvd",
        "template_2qsw9rf",
        e.target,
        "h3D44ArNXgKAdDsqF"
      )
      .then(
        (result) => {
          if (result.text) {
            alert("Your message has been send successfully");
            e.target.reset();
          }
        },
        (error) => {
          if (error.text) alert("Sorry, Message not send");
        }
      );
  };

  return (
    <section id="contact" className="contact">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Contact</h2>
          <p>
            We love to hear from you. Whether you have questions or need
            repairs, use our contact form to get in touch. You can also call or
            drop by our repair shop for assistance.
          </p>
        </div>

        <div className="row" data-aos="fade-up" data-aos-delay="100">
          {/* <div className="col-lg-12">
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3721.687222021053!2d73.10713511473321!3d21.125032485946306!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be067729cc00001%3A0xfa3ae55455e39a57!2sProgress%20Solution!5e0!3m2!1sen!2sin!4v1646368418385!5m2!1sen!2sin" width="1000" height="450" style={{border:'0'}} allowfullscreen="" loading="lazy"></iframe>
</div> */}
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-12">
                <div className="info-box">
                  <i className="bx bx-map"></i>
                  <h3>Our Address</h3>
                  <p>43, Mudit palace, Station road, Bardoli, 394601</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-box mt-4">
                  <i className="bx bx-envelope"></i>
                  <h3>Email Us</h3>
                  <p>progresssolutions13@gmail.com</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-box mt-4">
                  <i className="bx bx-phone-call"></i>
                  <h3>Call Us</h3>
                  <p>
                    +91 80000 73339
                    <br />
                    +91 90333 85131
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <form ref={form} onSubmit={sendEmail} className="php-email-form">
              <div className="row">
                <div className="col form-group">
                  <input
                    type="text"
                    name="from_name"
                    className="form-control"
                    id="from_name"
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="col form-group">
                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Your Email"
                    required
                  />
                </div>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  name="mobile"
                  id="mobile"
                  placeholder="Mobile"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  id="subject"
                  placeholder="Subject"
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  className="form-control"
                  name="message"
                  rows="2"
                  placeholder="Message"
                  required
                ></textarea>
              </div>
              <div className="my-3">
                <div className="loading">Loading</div>
                <div className="error-message"></div>
                <div className="sent-message">
                  Your message has been sent. Thank you!
                </div>
              </div>
              <div className="text-center">
                <button type="submit" value="Send">
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
